import { AxiosError } from 'axios';
import request from 'common/request';
import { useQuery } from 'react-query';

export const useGetPayCheck = ( options?: any) => {
  return useQuery<any, AxiosError>(
    'checkData',
    async () => {
      try {
        const response = await request.get(`/pay/check`,
        );
        return response;
      } catch (e) {
        //@ts-ignore
        const result = e.response
        return result
      }
    },
    {
      ...options,
    }
  );
};

export default useGetPayCheck;
